import axios from "../lib/axios";

export const addDegree = async (data) => {
  try {
    const response = await axios.post("/degree/add", data);
    return response.data;
  } catch (error) {
    throw new Error(
      error?.response?.data?.message || "Failed to create degree"
    );
  }
};

export const getAllDegrees = async () => {
  try {
    const response = await axios.get("/degree/all");
    return response.data;
  } catch (error) {
    throw new Error(
      error?.response?.data?.message || "Failed to fetch degrees"
    );
  }
};

export const updateDegree = async (id, data) => {
  try {
    const response = await axios.put(`/degree/${id}`, data);
    return response.data;
  } catch (error) {
    throw new Error(
      error?.response?.data?.message || "Failed to update degree"
    );
  }
};

export const deleteDegree = async (id) => {
  try {
    const response = await axios.delete(`/degree/${id}`);
    return response.data;
  } catch (error) {
    throw new Error(
      error?.response?.data?.message || "Failed to delete degree"
    );
  }
};
